import React, { useEffect, useState } from "react";

import { ApiValidationError, mapApiFieldValidationErrors, FormSubmitCallback } from "ui/Form"
import { GET_PEOPLE_WITH_SESSION_COUNT, GET_ROLES } from "ft-shared-graphql/queries";
import { ADD_PERSON_MUTATION } from "ft-shared-graphql/mutations"
import { useMutation, useQuery } from "@apollo/client";
import { GetRolesQuery, AddPersonMutation, AddPersonMutationVariables, PersonRole } from "ft-shared-graphql";
import { useSlideInContext } from "ui/SlideIn";
import { useManageModal } from "ui/Modal";
import { StaffForm, StaffFormSchema } from "../../Forms";
import { RoleDataType } from "ft-shared-graphql/types";

// const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
export type AddUserProps = {
    companyType: string
    onSubmit: () => void
}
const AddUser = ({ companyType, onSubmit }: AddUserProps) => {
    const [addPerson] = useMutation<AddPersonMutation, AddPersonMutationVariables>(ADD_PERSON_MUTATION, {
        refetchQueries: [GET_PEOPLE_WITH_SESSION_COUNT]
    })
    const [roleOptions, setRoleOptions] = useState<any[]>([]);
    const { toggleDrawer } = useSlideInContext();
    const { data, loading } = useQuery<GetRolesQuery>(GET_ROLES, {
        fetchPolicy: "no-cache",
        variables: { companyType: companyType }
    });
    const { openModal } = useManageModal()


    useEffect(() => {
        if (!data?.roles) return;
        const _roles = data?.roles ?? []
        setRoleOptions(_roles)
    }, [loading])
    const handleAddUserSubmission: FormSubmitCallback<StaffFormSchema> = async (values: StaffFormSchema): Promise<ReturnType<FormSubmitCallback>> => {
        const response = await addPerson({
            variables: {
                firstName: values.firstName,
                middleName: values.middleName,
                lastName: values.lastName,
                role: values.roleType as PersonRole,
                email: values.email,
                startDate: new Date()
                // startDate: values.startDate
            },
            onError(error, clientOptions) {
                openModal({ type: "GENERAL_ERROR" })
                console.log('Query error: ', error, clientOptions);
            }
        });

        // If type of "ValidationError" exists in the errors payload field
        // map errors to dicitonary and return. Final form will then 
        // render the errors to the each stated field
        // Note: must match form definition
        if (response.data?.addPerson.errors) {
            const validationError = response.data.addPerson.errors
                .find((e: any) => e.__typename === "ValidationError") as ApiValidationError;
            const businessRuleError = response.data.addPerson.errors
                .find((e: any) => e.__typename === "EntityBusinessRuleError") as ApiValidationError;
            if (validationError) {
                const fieldErrors = validationError
                    ? mapApiFieldValidationErrors(validationError)
                    : null;

                return fieldErrors;
            } else if (businessRuleError) {
                openModal({ type: "USER_CAP" })
            } else {
                openModal({ type: "GENERAL_ERROR" })
            }
        }
        onSubmit()
        toggleDrawer();
    };

    return (
        <StaffForm
            onSubmit={handleAddUserSubmission}
            initialValues={null}
            roles={roleOptions}
            onCancel={() => toggleDrawer()}
        />
    )
};

export default AddUser;
